import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface ButtonTooltipProps {
  id: string;
  messageId: string;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  children: React.ReactElement;
}

const ButtonTooltip: React.FC<ButtonTooltipProps> = ({
  id,
  messageId,
  placement = 'top',
  children,
}) => {
  const intl = useIntl();

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip id={id}>
          {intl.formatMessage({ id: messageId })}
        </Tooltip>
      }
    >
      <span className="d-inline-block">{children}</span>
    </OverlayTrigger>
  );
};

export default ButtonTooltip;
